export default __webpack_public_path__ + "static/media/user-neck.116f18ec.svg";